{
    "BroadworksSSO_NotAvailable_Error": "Broadworks SSO is not enabled on this server.\nPlease contact your administrator.",
    "BroadworksSSO_Token_Invalid_Error": "Login token was invalid or expired.\nPlease try logging in again.",
    "BroadworksSSO_Some_Param_Missing_Error": "One or more of the parameters required is missing.\nPlease try logging in again.",
    "BroadworksSSO_Invalid_Submit_Error": "Whoops... somethings not right. Please try again. If this problem persists please contact your administrator.",

    "BroadworksSSO_Device_Not_Found_In_Akixi": "Device with {} username \"{}\" was not found.\nPlease contact your administrator.",

    "BroadworksSSO_AkixiSignUp_Title": "You're almost done, just enter these details to finish setting up your account.",

    "BroadworksSSO_AkixiSignUp_Submit": "Register",

    "BroadworksSSO_Success": "You are all set!\n\nUser \"{}\" has been created.\nYou should have received an email with your login details.\nPlease check your inbox and follow the instructions to login.\n\nAlternatively, you can use the '{} User ID' Button on the landing page to login with in the future.\n\nClick the button below to login now.",
    "BroadworksSSO_Success_Button": "Login Now",

    "ContinueBroadworksSSO_Continue_Button": "{} User ID",
    "ContinueBroadworksSSO_Button_Info": "Enter a valid {} User ID to continue.",

    "NAME": "BroadworksSSO"
}